import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { Store } from '@ngxs/store';

import {
    AlertService,
    ButtonModule,
    ButtonTypes,
    TextfieldModule,
} from '@ed---interne/ng-uui-components';

import { emailValidator } from '../../../shared/validators/email.validator';
import { PasswordForgot } from '../../../core/states/auth.state';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        TextfieldModule,
        ButtonModule,
    ],
})
export class ForgotPasswordComponent {
    public ButtonTypes = ButtonTypes;

    public emailSentTo: string | undefined;

    public forgotPasswordFormGroup: FormGroup = this.formBuilder.group({
        email: ['', [emailValidator()]],
    });

    constructor(
        private readonly formBuilder: FormBuilder,
        private alertService: AlertService,
        private router: Router,
        private store: Store,
    ) {}

    public onSubmit(): void {
        this.passwordInit();
    }

    public async passwordInit() {
        const email = (this.emailSentTo || this.forgotPasswordFormGroup.value.email || '').trim();
        this.emailSentTo = email.toLowerCase();
        this.store
            .dispatch(
                new PasswordForgot({
                    email: email,
                }),
            )
            .subscribe({
                next: () => {
                    this.alertService.valid('Mot de passe oublié', 'Email renvoyé !');
                },
                error: () => {
                    this.alertService.valid('Mot de passe oublié', 'Email renvoyé !');
                },
            });
    }

    public send(): void {
        this.passwordInit();
        this.router.navigate(['/forgot-password']);
    }
}
